import { runDemo } from "../shared/demoRunner";
import { createDecalsScene } from "./scene";

runDemo({ createScene: createDecalsScene });
